import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Helper to save/load search history to localStorage
const loadSearchHistory = () => {
  try {
    const history = localStorage.getItem('ai_equity_search_history')
    return history ? JSON.parse(history) : []
  } catch (e) {
    return []
  }
}

const saveSearchHistory = (history) => {
  try {
    localStorage.setItem('ai_equity_search_history', JSON.stringify(history))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to save search history', e)
  }
}

export default new Vuex.Store({
  state: {
    searchQuery: '',
    searchHistory: loadSearchHistory(),
    reports: [],
    siteConfig: {}
  },
  getters: {
    getReportById: (state) => (id) => {
      return state.reports.find(report => report.id === id)
    },
    hotKeywords: () => {
      return ['百度', '腾讯', '科大讯飞', '商汤', '阿里', '大模型', '自动驾驶']
    }
  },
  mutations: {
    SET_SEARCH_QUERY(state, query) {
      state.searchQuery = query
    },
    ADD_TO_HISTORY(state, keyword) {
      if (!keyword || !keyword.trim()) return
      const cleanKeyword = keyword.trim()
      // Remove duplicate and unshift to first
      const index = state.searchHistory.indexOf(cleanKeyword)
      if (index > -1) {
        state.searchHistory.splice(index, 1)
      }
      state.searchHistory.unshift(cleanKeyword)
      // Cap history to 8 items
      if (state.searchHistory.length > 8) {
        state.searchHistory.pop()
      }
      saveSearchHistory(state.searchHistory)
    },
    CLEAR_HISTORY(state) {
      state.searchHistory = []
      saveSearchHistory([])
    },

    SET_SITE_CONFIG(state, config) {
      state.siteConfig = config || {}
    },

    UNLOCK_REPORT(state, reportId) {
      const report = state.reports.find(r => r.id === reportId)
      if (report) {
        report.isLocked = false
      }
    },
    ADD_REPORT(state, report) {
      if (!state.reports.some(r => r.id === report.id)) {
        state.reports.push(report)
      }
    }
  },
  actions: {
    addReport({ commit }, report) {
      commit('ADD_REPORT', report)
    },
    unlockReport({ commit }, id) {
      commit('UNLOCK_REPORT', id)
    }
  }
})
